import { render, staticRenderFns } from "./variable.vue?vue&type=template&id=b7f2e3c0&"
import script from "./variable.vue?vue&type=script&lang=js&"
export * from "./variable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports